import { httpPc } from "@/utils/httpPc";

export type DeliverTypeItem = {
    "id": string  // "59",
    "company_id": string  // "311",
    "name": string  // "快递",
    "type": string  // "1",
    "status": string  // "1",
    "is_default": string  // "0",
    "is_sys": string  // "1",
    "customer_type": string  // "0",
    "customer_region":string  //  "0",
    "create_time": string  // "2022-01-25 22:43:32",
    "update_time": string  // "2022-01-25 22:43:32",
    "is_delete": string  // "0"
}

export type ServiceDeliverTypeResponseType = {
    "count": number,
    "list": Array<DeliverTypeItem>
}

export const serviceDeliverType = (params:{kw?:string} = {})=>{
    return httpPc.get<AxiosHttpPromise<ServiceDeliverTypeResponseType>>('/Manager/FreightSet/getDistributionModeLists',{params });
}